import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: 'Quanto tempo serve al giorno?',
    answer: '10–15 minuti. La costanza vince la perfezione.'
  }, {
    question: 'È un abbonamento?',
    answer: 'No: pagamento unico, accesso a vita.'
  }, {
    question: 'Quando vedrò i primi risultati?',
    answer: 'Molti utenti notano progressi in 10–15 giorni.'
  }, {
    question: "Serve un'app?",
    answer: 'Accesso web immediato via e-mail, da qualsiasi dispositivo.'
  }, {
    question: 'Ho 70+ anni: è adatto?',
    answer: 'Sì. Il metodo è pensato per tutte le età adulte.'
  }];
  return <section id="faq" className="w-full bg-gray-50 py-20 px-4 sm:px-6 lg:px-8" data-id="element-53">
      <div className="max-w-3xl mx-auto" data-id="element-54">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-12 text-center" data-id="element-55">
          Domande Frequenti
        </h2>
        <div className="space-y-4" data-id="element-56">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-57">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex justify-between items-center p-6 text-left hover:bg-gray-50 transition-colors focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-inset" aria-expanded={openIndex === index} aria-controls={`faq-answer-${index}`} data-id="element-58">
                <span className="text-xl font-semibold text-gray-900 pr-4" data-id="element-59">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-gray-600 flex-shrink-0 transition-transform ${openIndex === index ? 'transform rotate-180' : ''}`} data-id="element-60" />
              </button>
              {openIndex === index && <div id={`faq-answer-${index}`} className="px-6 pb-6" role="region" data-id="element-61">
                  <p className="text-lg text-gray-700" data-id="element-62">{faq.answer}</p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}